<template>
	<div>
		<Header :sel='3' @changePhone="changePhone" />
		<!--neirong-->
		<div :class="['cd-main-content',showPhone?'nav-is-visible':'']">


			<!-- * 内页banner * -->
			<div class="page-banner">
				<img src="@/assets/images/banner04.png">
				<div class="nybt">
					<h3>业务范围</h3>
				</div>
			</div>
			
			<!-- * 当前位置 * -->
			<div class="page-position">
				<div class="wh">
					当前位置：
					<a href="/">首页</a>
					&gt;<a href="javascript:void(0)" @click="go('businessList1?type=100004&title=业务范围')" >业务范围</a>
					
					<span v-if="twoCategoryName"> ></span><a href="javascript:void(0)" @click="goBack" v-if="twoCategoryName">{{twoCategoryName}}</a>
					 <a href="javascript:void(0)">&gt;{{title}}</a>
				</div>
			</div>
			
			<!-- * 主体部分 * -->
			<div class="page-wrap">
				<div class="wh clearfix">
					<!-- * 左侧 * -->
			
			
					<!-- * 右侧 * -->
					<div class="page-wrap-right">
			
						<div class="xypg-left-con2 hidden-sm hidden-xs clearfix">
							<div>
								<ul class="xypg-left-nav">
									<li :class="item.categoryCode==type?'clicked':''" v-for="item in actList">
										<a href="javascript:void(0)"
											@click="changeData(item.categoryCode,item.categoryName)">
											{{item.categoryName}}</a>
										<div class="first-nav-btn"></div>
									</li>
								</ul>
							</div>
						</div>
			
			
			
						<div class="xypg-right-content">
							<!-- * 判断后台有没有录入多图 * -->
							<div>
								<!-- 产品详情页面 -->
								<div class="xypg-product-detail">
			
			
									<div class="product-detail-tab">
			
			
										<div class="product-detail-tabbox">
											<div class="product-detail-tabcon">
												<div v-html="szData.cmsArticleData?szData.cmsArticleData.content:''"></div>
												
											</div>
										</div>
									</div>
									<!-- 产品列表页 -->
									
									<div class="pro_title">相关产品</div>
									<ul class="xypg-product-list clearfix">
										<li v-for="item in list" @click="goBusDetail(item.id)">
											<a href="javascript:void(0)" class="img"><img
													:src="item.image" /></a>
											<h3><a href="javascript:void(0)">{{item.title}}</a></h3>
										</li>
									</ul>
									<div class="xypg-pagination">
										<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
											:current-page="pageNum" :page-sizes="[9, 18, 45, 90]"
											:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
											:total="total">
										</el-pagination>
									</div>
								</div>
							</div>
			
							<!-- * 最近浏览 * -->
							<!-- * 最近浏览 * -->
			
			
						</div>
					</div>
			
					<!-- * 手机弹窗 * -->
			
				</div>
			</div>

			<Footer />
		</div>



		<!--neirong-->


	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import axios from 'axios';


	import {
		articleDetail,articleList,categorysortPage
	} from '@/api/reqFetch.js'

	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header,
		},
		data() {
			return {
				id: '',
				detail: {},
				showPhone: false,
				pdfUrl: '',
				pdfDoc: null,
				pageNum: 1,
				pageCount: 0,
				title:'',
				type:'',
				list: [],
				pageNum: 1,
				pageSize:9,
				total:0,
				szData:{},
				actList:[],
				twoCategoryName:''
			}
		},

		mounted() {
			if(this.$route.query.type){
				this.type=this.$route.query.type
				this.title=this.$route.query.title
				this.twoCategoryName=this.$route.query.title
			}
			this.goBus();
			this.list=[]
			this.szData={}
			this.getData()
			this.checkCategoryCode()
		},

		methods: {
			goBack(){
				this.$router.go(-1)
			},
			changeData(id, title) {
				if(this.type==id){
					return
				}
				let url = '/businessDetail?type=' + id + '&title=' + title
				if(title=='共享智造'){
					url = '/businessList1?type=' + id + '&title=' + title
				}
				this.$router.push(url)	
				this.$router.go(0)
			},
			go(url) {
				if (this.$route.fullPath != url) {
					this.$router.push(url)
					this.$router.go(0)
				}
			},
			goBusDetail(id){
				this.$router.push({
					path: '/productDetail?id='+id,
				})
			},
			// 页码容量变化
			handleSizeChange(pageSize) {
				this.pageNum = 1
				this.pageSize = pageSize
				this.getData()
			},
			
			// 当前页码变化
			handleCurrentChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			
			getData() {
				let par = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					status: 1,
					categoryCode:this.type,
					isComment:1
				}
				articleList(par).then(res => {
					this.list = res.rows;
					this.total = res.total
				});
			},
			goBus(){
				articleList({
					pageNum: 1,
					pageSize: 1,
					status: 1,
					categoryCode: this.type,
					isComment:0
				}).then(res => {
					if(res.rows.length>0){
						this.getSzDetail(res.rows[0].id)
					}
					
				});
			},
			getSzDetail(id){
				articleDetail({
					id: id
				}).then(res => {
					this.szData = res.data;
					try {
							let cmsArticleData = this.szData.cmsArticleData
						if(cmsArticleData && cmsArticleData.content){
							// 正则替换空格&nbsp;为一个div元素，
							cmsArticleData.content = cmsArticleData.content.replace(/&nbsp;&nbsp;&nbsp;&nbsp;/g, '<div class="su-space"></div>')
						}
						this.szData = {
							...this.szData,
							cmsArticleData: cmsArticleData
						}
					} catch (error) {
						console.error(error)
					}
							
				});
			},
			goNext(url) {
				this.$router.push({
					path: url,
				})
			},

			changePhone(val) {
				this.showPhone = val
			},
			

			checkCategoryCode() {
				categorysortPage({
					pos: 'top'
				}).then(res => {
					this.twoCategoryName = ''
					res.data.map(item => {
						if (item.categoryName == '业务范围') {
						   this.actList = item.children
						   this.actList.sort((a, b) => a.orderNum - b.orderNum);
						   if(this.type.startsWith('3000')){
							  
						   		item.children.map(items=>{
							   this.twoCategoryName = items.categoryName
								if(items.categoryCode=='200011'){
									 this.actList = items.children
						             this.actList.sort((a, b) => a.orderNum - b.orderNum);
								}
							  })
						   }else{
							 this.actList = item.children
						     this.actList.sort((a, b) => a.orderNum - b.orderNum);
						   }
						}
					})

				});
			},

		}
	}
</script>

<style scoped>
	/*内容*/
	.banner {
		/* background-image: url('../../assets/images/banner_03.png'); */
	}

</style>